define('app/views/ajax_form_view',[
  'app/setup',
  'app/session',
  'app/lib/pwt/persian-date',
  'app/lib/pwt/persian-datepicker'],

  function(takhfifan, session, persianDate, pdp) {
  takhfifan.AjaxForm = Backbone.View.extend({

    events: {
      "submit" : "submitForm",
      "click .tkh-ajax-form__login": "toggleLoginForm",
      'change .tkh-ajax-form__has_relation': 'activateRelations'
    },

    initialize: function() {
      var _this = this;
      window.persianDate = persianDate;
      this.$submitBtn = this.$('button[type="submit"]');
      this.url = this.$el.prop('action');
      this.method = this.$el.prop('method');
      this.protected = this.$el.data('protected');
      this.successMessage = this.$('.tkh-ajax-form__success').html();
      if(this.$('.thk-form-recaptcha').length){
        this.loadRecaptcha();
        this.enableForm(!this.protected);
      }else{
        this.enableForm(!this.protected);
      }

      if(this.protected){
        if(session.customerIsLoggedIn()){
          var data = session.getCustomerData();
          this.$('.tkh-ajax-form__login').parent().hide();
          this.fillForm(data);
          this.enableForm(true);
        }else{
          takhfifan.eventHub.on('customer:login', function(data) {
            this.$('.tkh-ajax-form__login').parent().hide();
            this.enableForm(true);
            this.fillForm(data);
          }, this);
        }
      }

      this.generateDatePickers();

      this.$('.tkh-ajax-form__disabled').css('display','none');
      this.$('.tkh-ajax-form__disabled').find(':input').each(function(){
        $(this).prop("disabled","disabled");
      });

      this.$el.find('input[required]').on('change invalid', function() {
        var inputField = $(this).get(0);
        inputField.setCustomValidity('');
        if (!inputField.validity.valid) {
          var ph = $(this).attr('placeholder');
          inputField.setCustomValidity('لطفا ' + ph + ' را وارد کنید');
        }
      });

      if(this.$('.captcha').length){
        this.captchaLoad();
        this.enableForm(!this.protected);
      }else{
        this.enableForm(!this.protected);
      }
      //convert numbers for this class to english
      $( ".tkh-persian-number-converter" ).change(function(e) {
        var engNumberConverted=_this.toEnglishNumber($(e.target).val());
        $(e.target).val(engNumberConverted);
      });
    },
    // english number converter
    toEnglishNumber:function (strNum) {
      var pn = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"],
          en = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
          an = ["٠", "١", "٢", "٣", "٤", "٥", "٦", "٧", "٨", "٩"],
          cache = strNum;

      for (var i = 0; i < 10; i++) {
        var regex_fa = new RegExp(pn[i], 'g'),
            regex_ar = new RegExp(an[i], 'g');

        cache = cache.replace(regex_fa, en[i]);
        cache = cache.replace(regex_ar, en[i]);
      }
      return cache;
    },

    fillForm: function (data) {
      this.$el.find('#name').val(data.name);
      this.$el.find('#email').attr("readonly","readonly").val(data.email);
    },

    formatDate: function(unix){
      var currentDate = new Date(unix);
      return (currentDate.getFullYear()+"-"+this.addLeadingZero(currentDate.getMonth() +1) +"-"+this.addLeadingZero(currentDate.getDate()));
    },

    addLeadingZero: function (n) {
      var s = "0"+n;
      return s.substr(s.length-2);
    },

    generateDatePickers: function(){
      var _this = this,
        dpOptions = {
          onSelect: function(unix){
            var selectedDate=this.model.state.selected,
              $placeHolder = $(this.model.inputElement),
              selectedDateText = selectedDate.year+"/"+selectedDate.month+"/"+selectedDate.date;
              // selectedDateText = _this.formatDate(unix);
            $placeHolder.html(selectedDate.year+"/"+selectedDate.month+"/"+selectedDate.date);
            $placeHolder.addClass('date-picker-ph--has-value');

            if($placeHolder.data("type")==="from"){
              _this.$($placeHolder.data('target')).val(selectedDateText);

              _this.fromDP.touched = true;
              if (_this.toDP && _this.toDP.options && _this.toDP.options.minDate != unix) {
                var cachedValue = _this.toDP.getState().selected.unixDate;
                _this.toDP.options = {minDate: unix};
                if (_this.toDP.touched) {
                  _this.toDP.setDate(cachedValue);
                }
              }

            }else{
              _this.$($placeHolder.data('target')).val(selectedDateText);

              _this.toDP.touched = true;
              if(_this.fromDP && _this.fromDP.options && _this.fromDP.options.maxDate != unix){
                var cachedValue = _this.fromDP.getState().selected.unixDate;
                _this.fromDP.options = {maxDate: unix};
                if (_this.fromDP.touched) {
                  _this.fromDP.setDate(cachedValue);
                }
              }
            }
          },
          minDate: new Date(),
          maxDate: null,
          autoClose: true,
          toolbox:{
            calendarSwitch:{
              enabled: false
            }
          }
        };

      var $datePickers = $(".tkh-ajax-form__date-picker");
      $datePickers.each(function(){
        $(this).removeClass('date-picker-ph--has-value');
        $(this).html($(this).data("ph"));
      });

      if(this.fromDP){
        this.fromDP.options = dpOptions;
      }
      if(this.toDP){
        this.toDP.options = dpOptions;
      }
      if(!this.toDP || !this.fromDP){
        $datePickers.each(function(){
          var dp = $(this).pDatepicker(dpOptions);
          if($(this).data("type")==="from"){
            _this.fromDP = dp;
          }else{
            _this.toDP = dp;
          }
        });
      }
    },

    activateRelations: function (e) {
      var $target = $(e.target),
          $relations = $($target.data('relations')),
          $related = $($target.data('related'));

      $relations.css('display','none');
      $relations.find(':input').each(function(){
        $(this).prop("disabled","disabled");
      });

      $related.css('display','block');
      $related.find(':input').each(function(){
        $(this).removeAttr("disabled");
      });
    },

    enableForm: function(couldSubmit){
      this.$el.removeClass('loading-view');
      if(couldSubmit){
        this.$submitBtn.removeAttr("disabled");
      }
    },

    disableForm: function () {
      this.$el.addClass('loading-view');
      this.$submitBtn.prop("disabled", "disabled");
    },

    loadRecaptcha: function() {
      var src = "async!https://www.google.com/recaptcha/api.js?hl=fa",
        _this = this;
      require([src], function() {
        // _this.enableForm(true);
      });
    },

    toggleLoginForm: function(e) {
      e.preventDefault();
      takhfifan.eventHub.trigger('customer:loginForm');
    },

    submitForm: function(e){
      e.preventDefault();
      var _this = this;
        this.disableForm();
        var formData = this.$el.serialize();
        $.ajax({
          url: _this.url,
          type: _this.method,
          data: formData
        }).done(function(data) {
          if(data.success){
            takhfifan.eventHub.trigger('message:show', {
              type: 'success',
              msg: _this.successMessage
            });
            var userName = _this.$('#name').val(),
                userEmail = _this.$('#email').val();
            _this.$el[0].reset();
            if(_this.protected){
              _this.fillForm({name: userName, email: userEmail})
            }
          }else{
            takhfifan.eventHub.trigger('message:show', {
              type: 'error',
              msg: data.message || data.msg || "در برقراری ارتباط خطایی پیش آمد"
            });
          }
        }).fail(function() {
          takhfifan.eventHub.trigger('message:show', {
            type: 'error',
            msg: data.message || data.msg || "در برقراری ارتباط خطایی پیش آمد"
          });
        }).always(function() {
          _this.enableForm(true);
          _this.generateDatePickers();
          $.ajax({
            url: '/v4/api/captchas/generate',
            type: 'post',
            dataType: 'json',
            success: function (data) {
              grecaptcha.reset();
              $('.captchaImage').attr('src', data.image);
              $("[name='captcha_token']").val(data.token);
            }
          });
        });
    },

    captchaLoad: function() {
      $.ajax({
        url: '/v4/api/captchas/generate',
        type: 'post',
        dataType: 'json',
        success: function (data) {
          $('.captchaImage').attr('src', data.image);
          $("[name='captcha_token']").val(data.token);
        }
      });
    }
  });
});

